import * as React from "react";
import { connect } from "react-redux";
import { useDispatch } from "@teamprevent/customer-redux";

import { Menu, Loader, Dropdown, Grid, Container } from "semantic-ui-react";

import { isRequestActive } from "redux-request-loading";

import { DropdownAnchor } from "@teamprevent/common/header";

import { EnvironmentNameMenuItemOld } from "@teamprevent/common/header/EnvironmentNameMenuItemOld";

import { getConfig } from "@teamprevent/common/getConfig";

import { ApplicationState } from "../applicationState";
import { CurrentUser } from "../auth";

import { GET_CURRENT_USER } from "../auth";

import { changeCurrentUserCompanyContext } from "../auth/actions";

import { Link, push } from "redux-little-router";

interface HeaderStateProps {
    currentUser: CurrentUser;
    loadingUser: boolean;
}

export type HeaderProps = HeaderStateProps;

export const HeaderUnconnected: React.FC<HeaderProps> = (props: HeaderStateProps) => {
    const dispatch = useDispatch();
    const config = getConfig();

    const onChangeCompanyClick = React.useCallback(async (event: any, data: any) => {
        await dispatch(changeCurrentUserCompanyContext(data.value));
        await dispatch(push("/"));
    }, [dispatch]);

    const customerOptions = () => {
        return props.currentUser.customers.map((item => {
            return <Dropdown.Item onClick={onChangeCompanyClick} key={item.id} value={item.id}>{item.name}</Dropdown.Item>;
        }));
    };

    // This needs to be done properly when we have actual auth in
    const renderLoginMenu = () => {
        if (props.loadingUser) {
            return (
                <Menu.Item>
                    <Loader active />
                </Menu.Item>
            );
        }

        if (props.currentUser.authenticated) {
            return (
                <>
                    <Dropdown simple item text={props.currentUser.name}>
                        <Dropdown.Menu>
                            {
                                props.currentUser.canSwitchBetweenPortals &&
                                <DropdownAnchor href={config.EmployeePortal}>Go to Employee Portal</DropdownAnchor>
                            }
                            <DropdownAnchor href="/account/signout">Log out</DropdownAnchor>
                        </Dropdown.Menu>
                    </Dropdown>
                </>

            );
        }

        return (
            <Menu.Item><a href="/login">Login</a></Menu.Item>
        );
    };

    const renderCompany = () => {

        if (props.currentUser.authenticated)
        {
            if (props.currentUser.customers.length > 1)
            {
                return (
                    <Dropdown simple item text={props.currentUser.currentCustomer?.name}>
                        <Dropdown.Menu>
                            {customerOptions()}
                        </Dropdown.Menu>
                    </Dropdown>
                );
            }

            return (
                <Menu.Item name="Company Name" link><Link style={{ color: "white" }} href="/">{props.currentUser.currentCustomer?.name}</Link></Menu.Item>
            );
        }

        return null;
    };

    return (
        <>
            <Grid container padded="vertically" columns="equal" verticalAlign="middle" className="site-header">
                <Grid.Column>
                    <img className="tp-logo print" src="/assets/Optima_Health_Logo.svg" />
                    <Link href="/">
                        <img className="site-logo" src="/assets/myoh_Logo_Manager_RGB_Pos.svg" />
                    </Link>
                </Grid.Column>
                <Grid.Column textAlign="right" className="mobile hidden">
                    <Link href="/">
                        <img className="tp-logo" src="/assets/Optima_Health_Logo.svg" />
                    </Link>
                </Grid.Column>
            </Grid>
            <div className="header-menu">
                <Container>
                    <Menu>
                        <Menu.Item name="Home button" link><Link style={{ color: "white" }} href="/">Home</Link></Menu.Item>
                        <EnvironmentNameMenuItemOld />
                        <Menu.Item position="right">{renderLoginMenu()}</Menu.Item>
                        {renderCompany()}
                    </Menu>
                </Container>
            </div>
        </>
    );
};

const mapStateToProps = (state: ApplicationState): HeaderStateProps => ({
    currentUser: state.currentUser,
    loadingUser: isRequestActive(state, GET_CURRENT_USER)
});

export const Header = connect(mapStateToProps)(HeaderUnconnected);
